import { GridType } from "../../../../Entities/GridType";
import { DraftProjectCapacity } from "./DraftProjectCapacity";

export const DraftAllocationView = () => {
	return <DraftProjectCapacity gridType={GridType.Allocation} />
}